import { RatioOptions, UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentVideo } from './cms-component-video.interface';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../catalog/config/component.config';

export const CMS_COMPONENT_VIDEO_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentVideo.ID,
    name: 'Video',
    image: '/common/cms/video-component.png',
    tags: ['video', 'image', 'big', 'banner'],
    isAdvanced: true,
    priority: 30,
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        // video
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-positioning',
            title: 'Video'
        },
        {
            key: 'video_id',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL',
            default: ''
        },
        <NICmsContentField.IChoiceField>{
            key: 'video_provider',
            type: NICmsContentField.EFieldType.choice,
            title: 'Provider',
            options: [
                ...UndefinedOption,
                {
                    key: 'youtube',
                    title: 'YouTube'
                },
                {
                    key: 'vimeo',
                    title: 'Vimeo'
                }
            ],
            description: 'Choose a video provider'
        },
        {
            key: 'video_background',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Background Mode',
            default: true
        },
        {
            key: 'video_autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: true,
            canShow: (data: NCmsComponentVideo.IData) => !data?.video_background
        },
        {
            key: 'video_hide',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide',
            default: false
        },
        // background
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-background',
            title: 'Background'
        },
        {
            key: 'background_image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: undefined
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
